<template>
  <ul class="clearfix">
    <li
      v-for="(book, index) in booklist"
      :key="index"
      class="fl"
      @click="goSeeDetail(book.id)"
    >
      <dl>
        <dt>
          <a href="javaScript:"
            ><img v-lazy="imgURL + book.iconUrl" :alt="book.name"
          /></a>
        </dt>
        <dd>
          <a href="javaScript:">
            <h4 :title="book.name" class="name ellipsis">
              {{ book.name }}
            </h4>
          </a>
          <div class="author">
            <a
              href="javaScript:"
              class="authorName"
              v-if="book.author != undefined"
              >{{ book.author.name }}</a
            ><a href="#">/ {{ book.sort }}</a>
          </div>
        </dd>
      </dl>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    booklist: Array
  },
  methods: {
    goSeeDetail(bookid) {
      this.$router.push(`/bookdetail/${bookid}`);
    }
  }
};
</script>

<style lang="stylus" scoped>
ul
    margin 24px 23px 32px 20px
    li
        width 87px
        margin-right 51px
        &:last-child
            margin-right 0
        img
            width 87px
            height 109px
        dd
            width 100%
            overflow hidden
            .name
                margin 9px 0 11px
                font-size 14px
                color rgba(0, 0, 0, 1)
            .author
                font-size 12px
                width 100%
                color rgba(108, 108, 108, 1)
                height 17px
                line-height 17px
                a
                    display inline-block
                    vertical-align top
                    color #6C6C6C
                    &.authorName
                        width 50px
                        overflow hidden
                        text-overflow ellipsis // 文本溢出显示省略号
                        white-space nowrap // 文本不会换行（单行文本溢出）
</style>
